import _ from 'lodash';
import React from 'react';
import styled, { css } from 'styled-components';
import { Checkbox, ClearIcon, Container, TextInput } from 'ui/components/styled';
import { fadeIn } from 'ui/theme/keyframes';
import { spacing } from 'ui/theme/utils';
import AdvancedSearch from '../../AdvancedSearch';

const FilterComponent = ({
  width = '40%',
  placeholder = 'Search',
  value: initialValue = '',
  onFilter,
  clearValue = '',
  advancedSearch = false,
  advancedSearchOpen,
  setAdvancedSearchOpen,
  ...rest
}) => {
  const [value, setValue] = React.useState(initialValue);
  const animate = React.useRef(false);
  const delayedFilter = React.useCallback(
    _.debounce((v) => onFilter(v.trim()), 700),
    [onFilter]
  );

  const handleChange = (e) => {
    const { value } = e.target;
    setValue(value);
    if (onFilter) {
      delayedFilter(value);
    }
  };

  const handleClear = () => {
    animate.current = true;
    setValue(clearValue);
    if (onFilter) {
      delayedFilter(clearValue);
    }
  };

  const handleToggleAdvancedSearch = () => {
    setAdvancedSearchOpen(cur => !cur)
    setValue('');
  }

  React.useEffect(() => {
    if (initialValue === '' && value !== '') {
      setValue('');
    }
  }, [initialValue]);

  if (advancedSearchOpen && advancedSearch)
    return (
      <Container gap="8px" flexDirection="row" alignItems="center">
        <AdvancedSearch onFilter={onFilter} />
        {advancedSearch && (
          <Checkbox
            label="Enable advanced search"
            checked={advancedSearchOpen}
            onChange={handleToggleAdvancedSearch}
          />
        )}
      </Container>
    );

  return (
    <Container flexDirection="row" alignItems="center">
      <RelativeContainer {...rest} width={width} height="auto">
        <TextInput
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          variant="minimal"
          pr="40px"
        />
        {value ? <ClearIcon onClick={handleClear} /> : <SearchIcon animated={animate.current} />}
      </RelativeContainer>
      {advancedSearch && (
        <Checkbox
          label="Enable advanced search"
          checked={advancedSearchOpen}
          onChange={handleToggleAdvancedSearch}
        />
      )}
    </Container>
  );
};

const RelativeContainer = styled(Container)`
  position: relative;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ flexGrow }) => flexGrow && `flex-grow: ${flexGrow};`}
  ${(props) => spacing(props)}
`;

const SearchIcon = styled.img.attrs(() => ({
  src: '/assets/img/icons/search.svg',
  alt: 'search',
}))`
  ${({ animated }) =>
    animated &&
    css`
      animation: ${fadeIn} 300ms ease-in;
    `}
  position: absolute;
  top: 8px;
  right: 10px;
  width: 20px;
`;

export default FilterComponent;
